import {
    EditOutlined,
    ExclamationCircleFilled,
    FileTextOutlined,
    FileExcelOutlined,
    DisconnectOutlined,
} from "@ant-design/icons";
import { Button, Card, Col, List, Modal, Row, Space, Tabs, Tag } from "antd";
import * as XLSX from "xlsx";
import React, { createRef, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import Footer from "../../../components/Footer";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import { useBreadcrumbTitle } from "../../../contexts/BreadcrumbContext";
import { rightsService } from "../../../services/rightsService";
import axiosInstance from "../../../variables/api/axiosInstance";
import { API_URL, TOKEN } from "../../../variables/constants";
import { PDFDocument } from "pdf-lib";
import html2canvas from "html2canvas";
import axiosMultiPartDataInstance from "../../../variables/api/axiosMultiPartDatainstance";
import AvenantsTab from "./details/AvenantTab";
import DetailsTab from "./details/DetailsTab";
import { enginsPourAttestation } from "./details/enginsPourAttestation";
import FixEnginCategorieModal from "../../sinistres/components/FixEnginCategorieModal";
const { confirm } = Modal;

const { TabPane } = Tabs;

const DetailsContrat = () => {
    const { setPageTitle } = useBreadcrumbTitle();
    const [contrat, setContrat] = useState();
    const [activeTab, setActiveTab] = useState("details");
    const [tabId, setTabId] = useState("1");
    const [regle, setRegle] = useState(false);
    const [reglements, setReglements] = useState([]);
    const [reglement, setReglement] = useState();
    const [modalOpen, setModalOpen] = useState(false);
    const [modalAttOpen, setModalAttOpen] = useState(false);
    const [modalCEDEAOAttOpen, setModalCEDEAOAttOpen] = useState(false);
    const [printingCP, setPrintingCP] = useState(false);
    const [printingAttestation, setPrintingAttestation] = useState(false);
    const [printingCEDEAOAttestation, setPrintingCEDEAOAttestation] = useState(false);
    const [modalModePaiement, setModalModePaiement] = useState(false);
    const [banques, setBanques] = useState([]);
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState("");
    const [numeroAttestation, setNumeroAttestation] = useState("");
    const [modalIncorporation, setModalIncorporation] = useState(false);
    const [modalRetrait, setModalRetrait] = useState(false);
    const [modalAugmentation, setModalAugmentation] = useState(false);
    const [modalDiminution, setModalDiminution] = useState(false);
    const [modalProrogation, setModalProrogation] = useState(false);
    const [modalRemiseEnVigueur, setModalRemiseEnVigueur] = useState(false);
    const [modalSuspension, setModalSuspension] = useState(false);
    const [modalReportEffet, setModalReportEffet] = useState(false);
    const [modalTransfertGarantie, setModalTransfertGarantie] = useState(false);
    const [modalChangementVehicule, setModalChangementVehicule] = useState(false);
    const [detacherModalOpen, setDetacherModalOpen] = useState(false);
    const [detachingEnginCodeId, setDetachingEnginCodeId] = useState(null);
    const [modalRenouvellement, setModalRenouvellement] = useState(false);
    const [havingRistourne, setHavingRistourne] = useState(false);
    const [attestationDamaged, setAttestationDamaged] = useState(false);
    const [layout, setLayout] = useState("portrait"); // Default layout
    const [loadingPrinting, setLoadingPrinting] = useState(false);
    // Impression groupée d'une flotte : on imprime D'ABORD, et on n'attribue les
    // numéros en base qu'APRÈS confirmation manuelle que l'impression est bien sortie.
    const [awaitingBulkConfirm, setAwaitingBulkConfirm] = useState(false);
    const [pendingBulkPairs, setPendingBulkPairs] = useState([]);
    const [contratModal, setContratModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [reload, setReload] = useState(false);
    const [modalAvenantOrdre, setModalAvenantOrdre] = useState(false);
    const [modalAvenantOrdreEngin, setModalAvenantOrdreEngin] = useState(false);
    const [modalDuplicata, setModalDuplicata] = useState(false);
    const [modalResiliation, setModalResiliation] = useState(false);
    const [modalChangementProducteur, setModalChangementProducteur] = useState(false);
    const [preview, setPreview] = useState({});
    const [fixCategorieData, setFixCategorieData] = useState(null);
    const [hasCEDEAOGarantie, setHasCEDEAOGarantie] = useState(false);

    const param = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const label = contrat?.numeroPoliceM || contrat?.numeroPoliceP;
        if (label) setPageTitle(label);
        return () => setPageTitle(null);
    }, [contrat]);

    useEffect(() => {
        axiosInstance.get(`/api/contrat/preview/${param?.contratId}`).then((res) => {
            console.log("PREVIEW: ", res.data);
            setPreview(res.data);
        }).catch((err) => {
            const data = err?.response?.data;
            if (err?.response?.status === 422 && data?.code === "ENGIN_CATEGORIE_MANQUANTE") {
                setFixCategorieData({
                    enginCodeId: data.enginCodeId,
                    immatriculation: data.immatriculation,
                });
            } else {
                console.log(err);
            }
        });
        // Mêmes dépendances que l'effet de chargement du contrat : la prévisualisation
        // (primes, garanties, CEDEAO…) doit se réactualiser après un avenant « en place »
        // (même codeId), sinon elle reste figée sur l'ancienne version du contrat.
    }, [param?.contratId, modalAvenantOrdre, modalAvenantOrdreEngin, reload]);

    useEffect(() => {

        const cedeao = () => {
            console.log("Contrat CEDEAO", contrat);
            if (!Array.isArray(contrat?.engins)) {
                return false;
            }
            console.log("Contrat CEDEAO", contrat);
            return preview?.engins?.some((engin) => {
                const garantiesCandidates = [
                    ...(Array.isArray(engin?.compulsoryGuaranties) ? engin.compulsoryGuaranties : []),
                    ...(Array.isArray(engin?.sousGaranties) ? engin.sousGaranties : []),
                    ...(Array.isArray(engin?.garanties) ? engin.garanties : []),
                ];

                return garantiesCandidates?.some((garantie) => {
                    const label = `${garantie?.nom ?? ""} ${garantie?.code ?? ""}`.toUpperCase();
                    console.log("Label", label);
                    console.log("Label oui? ", label.includes("CEDEAO"));
                    return label.includes("CEDEAO");
                });
            });
        }
        const data = cedeao();
        setHasCEDEAOGarantie(data);

    }, [contrat, preview]);

    // const hasCEDEAOGarantie = useMemo(() => {
    //     if (!Array.isArray(contrat?.engins)) {
    //         return false;
    //     }
    //     console.log("Contrat CEDEAO", contrat);
    //     return contrat.engins.some((engin) => {
    //         const garantiesCandidates = [
    //             ...(Array.isArray(engin?.compulsoryGuaranties) ? engin.compulsoryGuaranties : []),
    //             ...(Array.isArray(engin?.sousGaranties) ? engin.sousGaranties : []),
    //             ...(Array.isArray(engin?.garanties) ? engin.garanties : []),
    //         ];

    //         return garantiesCandidates.some((garantie) => {
    //             const label = `${garantie?.nom ?? ""} ${garantie?.code ?? ""}`.toUpperCase();
    //             console.log("Label", label);
    //             return label.includes("CEDEAO");
    //         });
    //     });
    // }, [contrat]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const getStatusColor = (statut) => {
        const colors = {
            'VALIDE': '#10b981',
            'EN_PROPOSITION': '#f59e0b',
            'SUSPENDU': '#ef4444',
            'RESILIE': '#6b7280',
            'ANNULE': '#dc2626',
            'CORBEILLE': '#6b7280'
        };
        return colors[statut] || '#6b7280';
    };

    const getStatusText = (statut) => {
        const texts = {
            'VALIDE': 'Validé',
            'EN_PROPOSITION': 'En proposition',
            'SUSPENDU': 'Suspendu',
            'RESILIE': 'Résilié',
            'ANNULE': 'Annulé',
            'CORBEILLE': 'Corbeille'
        };
        return texts[statut] || statut;
    };

    useEffect(() => {
        // Remove any previously injected styles
        document.querySelectorAll("link[data-print-style]").forEach((el) => el.remove());

        // Create a new link element for the selected CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.type = "text/css";
        link.href = layout === "portrait" ? "/portrait.css" : "/landscape.css";
        link.setAttribute("data-print-style", "true");

        document.head.appendChild(link);
    }, [layout]);

    const onTabsChange = (key) => {
        // console.log(key);
        if (key === "3") {
            setModalAttOpen(true);
        }

        if (key === "5" && hasCEDEAOGarantie) {
            setModalCEDEAOAttOpen(true);
        }
        setTabId(key);
    };

    useEffect(() => {
        if (!hasCEDEAOGarantie) {
            setModalCEDEAOAttOpen(false);
            if (tabId === "5") {
                setTabId("1");
            }
        }
    }, [hasCEDEAOGarantie, tabId]);

    const loadPaymentModal = (rg) => {
        setReglement(rg);
        reglementWarningWithConfirmAndCancelMessage();
    };

    const printRefContrat = useRef();
    const printRefAttestation = useRef();
    const printReference = useRef();
    const printAttestation = createRef();
    const printedAttestation = useRef();
    // Flotte : un nœud DOM par engin (indexé sur l'ordre de contrat.engins) + index de l'engin
    // à imprimer. Évite qu'un ref partagé pointe toujours sur le DERNIER engin de la flotte.
    const attestationNodeRefs = useRef([]);
    const printAttestationIndex = useRef(0);
    const printedCEDEAOAttestation = useRef();
    const printAllAttestationsRef = useRef();
    const printRecu = createRef();

    const handlePrint = useReactToPrint({
        content: () => printReference.current,
        onAfterPrint: () => {
            setPrintingCP(false);
        },
    });

    const handleRecu = useReactToPrint({
        content: () => printRecu.current,
    });

    // Journalise un évènement d'impression (ActivityLog) — non bloquant.
    const logPrintEvent = (action, description) => {
        axiosInstance.post(`/api/activity-log/event`, {
            action,
            entityType: "Contrat",
            entityCodeId: contrat?.codeId,
            description,
        }).catch((e) => console.log("activity-log event error", e));
    };

    // Impression effective de la CP / proposition (endpoint /impression → pose dateImpression).
    const doPrintCP = () => {
        // La CP / proposition est TOUJOURS en PORTRAIT. On réinitialise ici le layout car une
        // impression d'attestation antérieure a pu basculer le <link> print sur /landscape.css :
        // sans ce reset, la CP héritait de l'orientation paysage de l'attestation.
        setLayout("portrait");
        setLoadingPrinting(true);
        setPrintingCP(true);
        axiosInstance.get(`/api/contrat/impression/codeId/${contrat?.codeId}/`)
            .then((res) => {
                setContrat(res.data);
                setTimeout(() => {
                    handlePrint();
                    setLoadingPrinting(false);
                }, 100);
                // Proposition si le contrat est en proposition, sinon condition particulière
                if (contrat?.statutContrat === "EN_PROPOSITION") {
                    logPrintEvent("CONTRACT_PROPOSITION_PRINT",
                        `Impression proposition ${contrat?.numeroPoliceM || contrat?.numeroPoliceP || ''}`);
                } else {
                    logPrintEvent("CONTRACT_CP_PRINT",
                        `Impression condition particulière ${contrat?.numeroPoliceM || contrat?.numeroPoliceP || ''}`);
                }
            })
            .catch((err) => {
                console.log(err);
                setLoadingPrinting(false);
                toast("Erreur lors de l'impression du contrat");
            });
    };

    const exportToPdf = () => {
        // Proposition : pas de garde attestation (l'attestation se tire après validation).
        if (contrat?.statutContrat === "EN_PROPOSITION") {
            doPrintCP();
            return;
        }
        // RÉIMPRESSION : si la CP a DÉJÀ été imprimée (dateImpression posée), on autorise la
        // réimpression directe SANS re-exiger l'attestation. L'obligation « attestation avant CP »
        // ne concerne que la PREMIÈRE impression ; elle bloquait à tort la réimpression des CP
        // anciennes (ou migrées sans n° d'attestation stocké).
        if (contrat?.dateImpression) {
            doPrintCP();
            return;
        }
        // Avenant d'annulation (AA) : aucune attestation n'est émise et la CP s'imprime avant le
        // règlement de la ristourne (justificatif à présenter en caisse) → pas de garde attestation.
        if (contrat?.avenant?.code === "AA") {
            doPrintCP();
            return;
        }
        // Contrat validé — OBLIGATION : imprimer l'attestation (N° CIMA) de CHAQUE engin AVANT la
        // condition particulière. Vérification sur données FRAÎCHES (le flux d'impression
        // d'attestation ne rafraîchit pas l'état local ; on lit donc le contrat à la source, via un
        // endpoint SANS effet de bord — /impression poserait dateImpression même en cas de blocage).
        setLoadingPrinting(true);
        axiosInstance.get(`/api/contrat/codeId/${contrat?.codeId}`)
            .then((res) => {
                const engins = res?.data?.engins || [];
                // Un engin « à l'immatriculation » (véhicule sans immatriculation encore attribuée)
                // ne peut PAS avoir d'attestation : son impression est conditionnée à la saisie
                // ultérieure de l'immatriculation. On l'exempte donc de l'obligation « attestation
                // avant CP » ; seuls les engins AYANT une immatriculation doivent avoir leur
                // attestation imprimée avant la condition particulière.
                // ATTENTION : ces engins portent une immatriculation NON VIDE = le seul préfixe pays
                // « TG » (typeSerie par défaut, sans numéro de série ni matricule). On considère donc
                // qu'il n'y a de VRAIE immatriculation que s'il reste du contenu après avoir retiré
                // « TG » et les séparateurs (ex. "TG" → aucune ; "TG-1234-AB" → "1234AB").
                const aImmatriculation = (e) => {
                    const reste = `${e?.immatriculation || ""}`.toUpperCase()
                        .replace(/TG/g, "").replace(/[^A-Z0-9]/g, "");
                    return reste.length > 0;
                };
                const attestationManquante = engins.length === 0
                    || engins.some((e) => aImmatriculation(e)
                        && (!e?.numeroAttestation || `${e.numeroAttestation}`.trim() === ""));
                if (attestationManquante) {
                    setLoadingPrinting(false);
                    toast.error("Veuillez d'abord imprimer l'attestation des engins immatriculés avant la condition particulière.");
                    return;
                }
                doPrintCP();
            })
            .catch((err) => {
                console.log(err);
                setLoadingPrinting(false);
                toast.error("Impossible de vérifier l'attestation. Veuillez réessayer.");
            });
    };

    const exportRecuToPdf = () => {
        handleRecu();
    };

    const exportAttestationToPdf = useReactToPrint({
        // Imprime le nœud de l'engin sélectionné (flotte) ; repli sur l'unique preview (mono-engin).
        content: () => attestationNodeRefs.current[printAttestationIndex.current] || printedAttestation.current,
    });

    const exportCEDEAOAttestationToPdf = useReactToPrint({
        content: () => printedCEDEAOAttestation.current,
        onBeforeGetContent: () => setPrintingCEDEAOAttestation(true),
    });

    const exportAllAttestationsToPdf = useReactToPrint({
        content: () => printAllAttestationsRef.current,
        // Une fois la boîte d'impression fermée (imprimé OU annulé), on demande à
        // l'utilisateur de confirmer que les attestations sont bien sorties avant
        // d'attribuer les numéros en base.
        onAfterPrint: () => {
            setLoadingPrinting(false);
            setAwaitingBulkConfirm(true);
        },
    });

    // Impression groupée d'une flotte. ÉTAPE 1 : on imprime seulement (un seul job
    // contenant toutes les attestations, dans l'ordre de saisie = ordre physique
    // dans l'imprimante). AUCUNE attribution de numéro n'est faite ici : tant que
    // l'utilisateur n'a pas confirmé que l'impression est bien sortie, les numéros
    // restent disponibles. La confirmation se fait via confirmBulkPrintSuccess().
    const printAllAttestations = (numeros) => {
        // Incorporation (IN) : n'imprimer QUE les engins incorporés (aligné sur l'affichage).
        const engins = enginsPourAttestation(contrat);

        if (!numeros || numeros.length === 0) {
            toast.warning("Veuillez d'abord saisir les numéros d'attestations.");
            return;
        }

        const pairs = engins
            .map((eng, i) => ({ eng, numero: numeros[i] }))
            .filter((p) => p.numero != null);

        if (pairs.length === 0) {
            toast.warning("Aucun numéro à attribuer aux engins.");
            return;
        }

        // On mémorise les couples (engin → numéro) pour l'attribution après confirmation.
        setPendingBulkPairs(pairs);
        setLoadingPrinting(true);
        setLayout("landscape");
        setPrintingAttestation(true);
        // Laisse le temps au ré-rendu (version ToPrint + layout paysage) avant d'imprimer.
        setTimeout(() => {
            exportAllAttestationsToPdf();
        }, 400);
    };

    // ÉTAPE 2 : l'utilisateur confirme que l'impression est bien sortie → on attribue
    // alors seulement les numéros en base (dans l'ordre de saisie).
    const confirmBulkPrintSuccess = () => {
        const pairs = pendingBulkPairs;
        if (!pairs || pairs.length === 0) {
            setAwaitingBulkConfirm(false);
            return;
        }

        setLoadingPrinting(true);

        Promise.allSettled(
            pairs.map((p) =>
                // contratCodeId : lève l'ambiguïté quand l'engin a été rattaché à plusieurs
                // contrats actifs (compagnies différentes) — le lot appartient à la compagnie
                // DU CONTRAT imprimé, pas à celle devinée depuis l'engin.
                axiosInstance.get(`/api/engin/attestation/${p.eng.codeId}/${p.numero}/CIMA?contratCodeId=${contrat?.codeId}`)
            )
        )
            .then((results) => {
                const failed = [];
                results.forEach((r, idx) => {
                    if (r.status === "rejected" || r.value?.status === 226) {
                        failed.push(pairs[idx].numero);
                    }
                });

                if (failed.length) {
                    toast.warning(
                        `Numéro(s) non enregistré(s) (inexistant(s) ou déjà utilisé(s)) : ${failed.join(", ")}`
                    );
                } else {
                    toast.success("Numéros d'attestation attribués avec succès.");
                }

                logPrintEvent(
                    "ATTESTATION_PRINT_BULK",
                    `Impression groupée de ${pairs.length} attestation(s) confirmée - ${contrat?.numeroPoliceM || contrat?.numeroPoliceP || ''}`
                );

                setAwaitingBulkConfirm(false);
                setPendingBulkPairs([]);
                setPrintingAttestation(false);
                setLoadingPrinting(false);
                setReload((prev) => !prev); // recharge le contrat → numéros visibles
                onTabsChange("1");
                setModalAttOpen(false);
            })
            .catch((err) => {
                console.log(err);
                setLoadingPrinting(false);
                toast.error("Erreur lors de l'attribution des numéros d'attestation.");
            });
    };

    // L'impression a échoué/bourré → on relance le même job d'impression SANS rien
    // attribuer. Les numéros restent intacts.
    const retryBulkPrint = () => {
        setAwaitingBulkConfirm(false);
        setLoadingPrinting(true);
        setTimeout(() => {
            exportAllAttestationsToPdf();
        }, 300);
    };

    // L'utilisateur abandonne : aucune attribution, on remet l'affichage normal.
    const abortBulkPrint = () => {
        setAwaitingBulkConfirm(false);
        setPendingBulkPairs([]);
        setPrintingAttestation(false);
        setLoadingPrinting(false);
    };

    const reglementWarningWithConfirmAndCancelMessage = () => {
        setModalModePaiement(true);
    };

    // Rafraîchit le contrat affiché SANS recharger la page : re-déclenche les deux
    // useEffect de chargement (contrat + règlements + preview) via l'état `reload`.
    // À utiliser par les avenants « en place » (codeId inchangé) à la place de
    // window.location.reload() ; quand l'avenant crée un nouveau codeId, un simple
    // navigate(`/details-contrat/${codeId}`) suffit (param.contratId change).
    const refreshContrat = () => setReload((prev) => !prev);

    const loadModal = (rg) => {
        setReglement(rg);
        setTimeout(() => {
            setModalOpen(true);
        }, 100);
    };

    useEffect(() => {
        if (param.contratId) {
            axiosInstance.get(`/api/contrat/codeId/${param.contratId}`)
                .then((res) => {
                    // console.log(res.data);
                    const reglements = res.data.reglements || [];
                    console.log("Reglements: ", reglements);
                    const hasIncompleteReglement = reglements?.some(r =>
                        !r.annule && !r.modePaiement && !r.dateReglement
                    );
                    console.log("Has incomplete reglement0", hasIncompleteReglement)
                    if (!hasIncompleteReglement) {
                        console.log("Has incomplete reglement");
                        setRegle(true);
                    } else {
                        setRegle(false);
                    }
                    if (!reglements || reglements.length === 0) {
                        setRegle(false);
                    }
                    setContrat(res.data);
                    // Mouvements reconstitués par la CHAÎNE d'historisation (code_id de la version courante),
                    // indépendamment du numéro de police : robuste aux polices divergentes entre versions
                    // (anciennes régénérations à la validation) et aux doublons de numero_police_p (reprises).
                    // Repli sur la recherche par couple (P, M) si le code_id est absent.
                    const mouvementsUrl = res.data.codeId
                        ? `/api/reglement/contrat-chain/${encodeURIComponent(res.data.codeId)}`
                        : `/api/reglement/police/${res.data.numeroPoliceP}?m=${encodeURIComponent(res.data.numeroPoliceM || "")}`;
                    axiosInstance.get(mouvementsUrl)
                        .then((resp) => {
                            console.log("Reglll: ", resp.data);
                            const regs = resp.data;
                            const hasIR = regs?.some(r =>
                                !r.annule && !r.modePaiement && !r.dateReglement
                            );
                            console.log("Has incomplete reglement222", hasIR)
                            if (!hasIR) {
                                console.log("Has incomplete reglement222");
                                setRegle(true);
                            } else {
                                setRegle(false);
                            }
                            if (!regs || regs.length === 0) {
                                setRegle(false);
                            }
                            setReglements(resp.data);
                        })
                        .catch((err) => {
                            console.log(err);
                        });

                    axiosInstance.get(`/api/reglement/check-ristourne/${res.data?.souscripteur?.numeroAssureP}`)
                        .then((resp) => {
                            // console.log("Having ristourne: ", resp.data);
                            setHavingRistourne(resp.data);
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                    res.data?.engins && res.data?.engins.forEach((e) => {
                        if (e?.carteGrise) {
                            // console.log(e.carteGrise);
                            fetch(
                                `${API_URL}/api/engin/carte-grise/${e?.carteGrise?.split("/")[1]
                                }`,
                                {
                                    headers: {
                                        Authorization: `Bearer ${TOKEN}`,
                                        "Content-Type": "application/json",
                                        "Access-Control-Allow-Origin": "*",
                                        "Access-Control-Allow-Methods":
                                            "GET, PUT, POST, DELETE, OPTIONS",
                                        "Access-Control-Allow-Headers":
                                            "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
                                    },
                                }
                            )
                                .then(async (response) => {
                                    // console.log("The response", response);

                                    // convert byte to file
                                    const imageBytes = await response.arrayBuffer();
                                    // console.log("images byte: ", imageBytes);
                                    var blob = new Blob([imageBytes], {
                                        type: "application/pdf",
                                    });
                                    // console.log("Blob: ", blob);
                                    var imageUrl = URL.createObjectURL(blob);
                                    // console.log("Image URL: ", imageUrl);
                                    setPdfPreviewUrl(imageUrl);
                                    var file = new File([blob], e.carteGrise.split("//")[2], {
                                        type: "application/pdf",
                                    });
                                    // console.log("File: ", file);
                                })
                                .catch((error) => {
                                    console.log(error);
                                });
                        }
                    });
                    // console.log("Contrat: ", contrat);
                })
                .catch((err) => {
                    console.log(err);
                }).finally(() => {
                    setLoading(false);
                });
        }

        axiosInstance.get(`/api/parametre/type/BANQUE`)
            .then((res) => {
                setBanques(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [param.contratId, modalAvenantOrdre, modalAvenantOrdreEngin, reload]);

    // `numero` : numéro à imprimer pour CET engin. En flotte, chaque engin a son propre numéro
    // (passé explicitement par ImprimerAttestation) ; repli sur le numéro partagé (mono-engin).
    const attestationPrinting = (engin, numero = numeroAttestation) => {
        // Cible l'engin cliqué (et non le dernier de la flotte) pour l'impression.
        const idxImpr = enginsPourAttestation(contrat).findIndex((e) => e.codeId === engin.codeId);
        printAttestationIndex.current = idxImpr >= 0 ? idxImpr : 0;
        axiosInstance.get(`/api/engin/attestation/${engin.codeId}/${numero}/CIMA?contratCodeId=${contrat?.codeId}`)
            .then((res) => {
                console.log(res);
                if (res.status === 226) {
                    toast("Ce numéro d'attestation n'existe pas ou est déjà utilisé");
                } else {
                    console.log("Export data");
                    exportAttestationToPdf();
                    onTabsChange("1");
                    setModalAttOpen(false);
                    logPrintEvent("ATTESTATION_PRINT",
                        `Impression attestation n° ${numero} - ${contrat?.numeroPoliceM || contrat?.numeroPoliceP || ''}`);
                }
                setLoadingPrinting(false);
            })
            .catch((err) => {
                console.log(err);
                setLoadingPrinting(false);
            });
    };

    const attestationDamagedPrinting = (engin) => {
        // console.log("update printing");
        setAttestationDamaged(true);

    };

    const attestationCEDEAODamagedPrinting = (engin) => {
        // console.log("update printing");
        setAttestationDamaged(true);

    };

    const printingDamagedAttestation = (engin, numero = numeroAttestation) => {
        const idxImpr = enginsPourAttestation(contrat).findIndex((e) => e.codeId === engin.codeId);
        printAttestationIndex.current = idxImpr >= 0 ? idxImpr : 0;
        axiosInstance.get(`/api/engin/attestation/damaged/${engin.codeId}/${numero}/SIMPLE?contratCodeId=${contrat?.codeId}`)
            .then((res) => {
                console.log(res);
                if (res.status === 226) {
                    toast.warning(
                        "Ce numéro est déjà utilisé (ou hors de votre stock disponible). " +
                        "Pour une attestation endommagée, saisissez un NOUVEAU numéro encore disponible — " +
                        "l'ancien sera automatiquement marqué comme endommagé."
                    );
                } else {
                    console.log("Export data");
                    exportAttestationToPdf();
                    onTabsChange("1");
                    setModalAttOpen(false);
                    logPrintEvent("ATTESTATION_REPRINT_DAMAGED",
                        `Réimpression attestation endommagée n° ${numero} - ${contrat?.numeroPoliceM || contrat?.numeroPoliceP || ''}`);
                }
            })
            .catch((err) => {
                console.log(err);
                const msg = err?.response?.data?.message
                    || "Erreur lors de l'impression de l'attestation endommagée";
                toast.error(msg);
            })
            .finally(() => {
                setLoadingPrinting(false);
                setPrintingAttestation(false);
            });
    }

    const printingDamagedCEDEAOAttestation = (engin) => {
        axiosInstance.get(`/api/engin/attestation/damaged/${engin.codeId}/${numeroAttestation}/SIMPLE?contratCodeId=${contrat?.codeId}`)
            .then((res) => {
                console.log(res);
                if (res.status === 226) {
                    toast.warning(
                        "Ce numéro est déjà utilisé (ou hors de votre stock disponible). " +
                        "Pour une attestation endommagée, saisissez un NOUVEAU numéro encore disponible — " +
                        "l'ancien sera automatiquement marqué comme endommagé."
                    );
                } else {
                    console.log("Export data");
                    exportCEDEAOAttestationToPdf();
                    onTabsChange("1");
                    setModalAttOpen(false);
                    logPrintEvent("ATTESTATION_REPRINT_DAMAGED",
                        `Réimpression attestation CEDEAO endommagée n° ${numeroAttestation} - ${contrat?.numeroPoliceM || contrat?.numeroPoliceP || ''}`);
                }
            })
            .catch((err) => {
                console.log(err);
                const msg = err?.response?.data?.message
                    || "Erreur lors de l'impression de l'attestation endommagée";
                toast.error(msg);
            })
            .finally(() => {
                setLoadingPrinting(false);
                setPrintingAttestation(false);
            });
    }

    const attestationNonPrintedPrinting = (engin) => {
        // Réimpression d'une attestation déjà numérotée mais non sortie
        // (délestage, bourrage sans dégât...). Aucun appel backend : on ne
        // consomme pas de nouveau numéro, on ne marque rien comme endommagé.
        // On bascule sur la version ToPrint puis on imprime après le ré-rendu.
        // Cible l'engin cliqué (flotte) et non le dernier / un index périmé.
        const idxImpr = enginsPourAttestation(contrat).findIndex((e) => e.codeId === engin?.codeId);
        printAttestationIndex.current = idxImpr >= 0 ? idxImpr : 0;
        setLayout("landscape");
        setPrintingAttestation(true);
        setLoadingPrinting(true);
        setTimeout(() => {
            exportAttestationToPdf();
            onTabsChange("1");
            setModalAttOpen(false);
            setLoadingPrinting(false);
            logPrintEvent("ATTESTATION_REPRINT_NONPRINTED",
                `Réimpression (impression non effectuée) - ${contrat?.numeroPoliceM || contrat?.numeroPoliceP || ''}`);
        }, 300);
    };

    const attestationCEDEAONonPrintedPrinting = () => {
        setLayout("landscape");
        setPrintingCEDEAOAttestation(true);
        setLoadingPrinting(true);
        setTimeout(() => {
            exportCEDEAOAttestationToPdf();
            onTabsChange("1");
            setModalCEDEAOAttOpen(false);
            logPrintEvent("ATTESTATION_REPRINT_NONPRINTED",
                `Réimpression CEDEAO (impression non effectuée) - ${contrat?.numeroPoliceM || contrat?.numeroPoliceP || ''}`);
            setLoadingPrinting(false);
        }, 300);
    };

    const showContractValidationConfirm = () => {
        confirm({
            title: "Etes-vous sûr de vouloir valider ce contrat?",
            icon: <ExclamationCircleFilled />,
            content: "Toutes vos actions sont historisées!",
            okText: "Oui",
            okType: "danger",
            cancelText: "Annuler",
            // On RETOURNE la promesse : antd garde la modale ouverte avec un spinner
            // sur le bouton "Oui" jusqu'à la fin de l'appel, ce qui empêche les
            // double-clics et donne un vrai retour visuel pendant la validation.
            onOk() {
                return validateContrat();
            },
            onCancel() { },
        });
    };

    const validateContrat = () => {
        // Validation selon le type :
        //  - Renouvellement (RN) : endpoint dédié (règlement spécifique + écriture).
        //  - Autres avenants financiers (PR, IN, AG, DG, TG, RV, CV) : validation générique.
        //  - Affaire nouvelle : validation standard.
        const code = contrat?.avenant?.code;
        const isRenouvellement = code === "RN";
        // CV (changement de véhicule) : comme la RV, la proposition génère son règlement
        // encaissable à la VALIDATION → doit passer par /avenant/valider (validerAvenant),
        // sinon elle tombe sur la validation d'affaire nouvelle et aucun règlement n'est créé.
        const isFinancialAvenant = ["PR", "IN", "AG", "DG", "TG", "RV", "CV"].includes(code);
        let request;
        if (isRenouvellement) {
            request = axiosInstance.put(`/api/contrat/renouvellement/valider/${contrat?.codeId}`);
        } else if (isFinancialAvenant) {
            request = axiosInstance.put(`/api/contrat/avenant/valider/${contrat?.codeId}`);
        } else {
            request = axiosInstance.get(`/api/contrat/valider/${contrat?.codeId}`);
        }
        // On RETOURNE la promesse pour que le bouton "Oui" de la modale reste en
        // chargement jusqu'à la résolution (anti double-clic + feedback).
        return request
            .then((res) => {
                toast.success((isRenouvellement || isFinancialAvenant) ? "Avenant validé avec succès" : "Contrat validé avec succès");
                navigate(`/details-contrat/${res.data.codeId}`, { replace: true });
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
                toast.error("Erreur lors de la validation");
            });
    };

    // Annulation du DERNIER avenant (le contrat affiché) depuis l'onglet Contrat — autorisée
    // uniquement s'il n'est pas encore réglé. Marque l'avenant ANNULÉ + annule sa ligne de règlement.
    const showCancelAvenantConfirm = () => {
        confirm({
            title: "Annuler cet avenant ?",
            icon: <ExclamationCircleFilled />,
            content: "L'avenant sera marqué ANNULÉ et sa ligne de règlement annulée. "
                + "L'écriture d'émission sera contrepassée. Action sensible et historisée.",
            okText: "Oui, annuler l'avenant",
            okType: "danger",
            cancelText: "Retour",
            onOk() {
                return axiosInstance.put(`/api/contrat/avenant/annuler/${contrat?.codeId}`)
                    .then(() => {
                        toast.success("Avenant annulé. Sa ligne de règlement a été annulée.");
                        window.location.reload();
                    })
                    .catch((err) => {
                        const msg = err?.response?.data?.message || "Erreur lors de l'annulation de l'avenant";
                        toast.error(msg);
                    });
            },
            onCancel() { },
        });
    };

    // Annulation de la VALIDATION d'une affaire nouvelle (AN) validée NON encaissée : ramène le
    // contrat à l'état Proposition (toutes les informations conservées, re-validation possible).
    // Le backend refuse l'opération si un encaissement existe déjà.
    const showCancelValidationConfirm = () => {
        confirm({
            title: "Annuler la validation de ce contrat ?",
            icon: <ExclamationCircleFilled />,
            content: "Le contrat repassera à l'état Proposition. Toutes ses informations sont conservées "
                + "et il pourra être re-validé. Opération impossible si un encaissement existe déjà.",
            okText: "Oui, ramener en proposition",
            okType: "danger",
            cancelText: "Retour",
            onOk() {
                return axiosInstance.put(`/api/contrat/devalider/${contrat?.codeId}`)
                    .then((res) => {
                        toast.success("Validation annulée : le contrat est de nouveau une proposition.");
                        navigate(`/details-contrat/${res.data.codeId}`, { replace: true });
                        window.location.reload();
                    })
                    .catch((err) => {
                        const msg = err?.response?.data?.message
                            || "Erreur lors de l'annulation de la validation";
                        toast.error(msg);
                    });
            },
            onCancel() { },
        });
    };

    // Annulation DÉFINITIVE d'un contrat VALIDÉ dont la date d'effet est encore FUTURE
    // (après la prise d'effet, c'est la résiliation qui s'applique). Le backend contrepasse
    // l'écriture d'émission, annule les règlements en attente et historise une nouvelle
    // version au statut ANNULE ; le contrat est ensuite définitivement figé.
    const showAnnulationContratConfirm = () => {
        confirm({
            title: "Annuler définitivement ce contrat ?",
            icon: <ExclamationCircleFilled />,
            content: "Le contrat passera au statut ANNULÉ : l'écriture d'émission sera contrepassée, "
                + "ses règlements en attente seront annulés et plus aucune opération (avenant, "
                + "renouvellement, résiliation…) ne sera possible. Si un encaissement existe déjà, "
                + "annulez d'abord le règlement encaissé.",
            okText: "Oui, annuler le contrat",
            okType: "danger",
            cancelText: "Retour",
            onOk() {
                return axiosInstance.put(`/api/contrat/annuler/${contrat?.codeId}`)
                    .then((res) => {
                        toast.success("Contrat annulé définitivement.");
                        navigate(`/details-contrat/${res.data.codeId}`, { replace: true });
                        window.location.reload();
                    })
                    .catch((err) => {
                        const msg = err?.response?.data?.message
                            || "Erreur lors de l'annulation du contrat";
                        toast.error(msg);
                    });
            },
            onCancel() { },
        });
    };

    // Annulation manuelle d'une PROPOSITION (contrat EN_PROPOSITION) : la déplace dans la
    // corbeille via un changement de statut côté backend. Aucune suppression physique.
    const showCancelPropositionConfirm = () => {
        // Avenant ≠ AN : l'annulation REVERT l'avenant (le contrat revient à sa version précédente).
        // AN : mise en corbeille (restaurable).
        const avCode = (contrat?.avenant?.code || "").toUpperCase();
        const estAvenant = !!avCode && !avCode.startsWith("AN");
        confirm({
            title: estAvenant ? "Annuler cet avenant ?" : "Annuler cette proposition ?",
            icon: <ExclamationCircleFilled />,
            content: estAvenant
                ? "L'avenant sera annulé : le contrat reviendra à sa version précédente. "
                    + "La proposition de l'avenant est abandonnée (non restaurable)."
                : "La proposition sera déplacée dans la corbeille. Elle reste une proposition "
                    + "(non supprimée) et pourra être restaurée depuis la corbeille.",
            okText: estAvenant ? "Oui, annuler l'avenant" : "Oui, mettre en corbeille",
            okType: "danger",
            cancelText: "Retour",
            onOk() {
                return axiosInstance.put(`/api/contrat/proposition/corbeille/${contrat?.codeId}`)
                    .then((res) => {
                        if (estAvenant) {
                            toast.success("Avenant annulé : le contrat est revenu à sa version précédente.");
                            // Rediriger vers la version RESTAURÉE (validée → pas de preview, pas de 422).
                            const restoredId = res?.data?.codeId;
                            if (restoredId) navigate(`/details-contrat/${restoredId}`, { replace: true });
                            else navigate("/propositions");
                        } else {
                            toast.success("Proposition déplacée dans la corbeille.");
                            // On NE recharge PAS la page détail (cela relancerait le preview de cette
                            // proposition, source du 422 sur les motos sans tarif RC). On va à la liste.
                            navigate("/propositions");
                        }
                    })
                    .catch((err) => {
                        const msg = err?.response?.data?.message
                            || "Erreur lors de l'annulation de la proposition";
                        toast.error(msg);
                    });
            },
            onCancel() { },
        });
    };

    // Restauration d'une proposition depuis la corbeille : retire le drapeau corbeille.
    // La proposition (toujours EN_PROPOSITION) réapparaît dans la liste des propositions.
    const showRestorePropositionConfirm = () => {
        confirm({
            title: "Restaurer cette proposition ?",
            icon: <ExclamationCircleFilled />,
            content: "La proposition sortira de la corbeille et reviendra dans la liste des propositions en cours.",
            okText: "Oui, restaurer",
            cancelText: "Retour",
            onOk() {
                return axiosInstance.put(`/api/contrat/proposition/restaurer/${contrat?.codeId}`)
                    .then(() => {
                        toast.success("Proposition restaurée.");
                        // Redirection vers la liste des propositions (où l'élément réapparaît),
                        // plutôt qu'un rechargement de la page détail.
                        navigate("/propositions");
                    })
                    .catch((err) => {
                        const msg = err?.response?.data?.message
                            || "Erreur lors de la restauration de la proposition";
                        toast.error(msg);
                    });
            },
            onCancel() { },
        });
    };

    const attestationCEDEAOPrinting = (engin, numeroAttestation) => {
        // CEDEAO : impression directe (paysage, une seule page). Le numéro d'attestation est
        // FACULTATIF ; on enregistre systématiquement une ligne (n° + immat + police + date effet)
        // pour l'état des attestations CEDEAO imprimées, sans bloquer l'impression si l'API échoue.
        axiosInstance.post(`/api/attestation-cedeao/imprimee`, {
            numeroAttestation: numeroAttestation || null,
            enginCodeId: engin?.codeId,
            immatriculation: engin?.immatriculation,
            contratCodeId: contrat?.codeId,
            numeroPolice: contrat?.numeroPoliceM || contrat?.numeroPoliceP,
            dateEffet: contrat?.dateEffet,
            organismeCode: contrat?.organisme?.code,
            organismeNom: contrat?.organisme?.raisonSociale,
        }).catch((e) => console.log("Enregistrement attestation CEDEAO:", e));

        setLayout("landscape");
        setPrintingCEDEAOAttestation(true);
        setLoadingPrinting(true);
        setTimeout(() => {
            exportCEDEAOAttestationToPdf();
            onTabsChange("1");
            setModalCEDEAOAttOpen(false);
            setLoadingPrinting(false);
            logPrintEvent("ATTESTATION_PRINT",
                `Impression attestation CEDEAO${numeroAttestation ? ` N° ${numeroAttestation}` : ''} - ${contrat?.numeroPoliceM || contrat?.numeroPoliceP || ''} - ${engin?.immatriculation || ''}`);
        }, 300);
    };

    // Réparation (HCO103) : détache un engin PARTAGÉ à tort avec d'autres contrats
    // (véhicules « à l'immatriculation »). Crée un engin propre au contrat courant, immatriculation
    // vierge, sans supprimer la plaque de l'engin d'origine (elle reste au contrat propriétaire).
    const detacherEnginPartage = (engin) => {
        const police = contrat?.numeroPoliceP || contrat?.numeroPoliceM;
        if (!engin?.codeId || !police) {
            toast.error("Engin ou police introuvable.");
            return;
        }
        setDetachingEnginCodeId(engin.codeId);
        axiosInstance
            .post(`/api/engin/split-partage/${engin.codeId}?policeVictime=${encodeURIComponent(police)}`)
            .then((res) => {
                toast.success(
                    `Engin détaché : nouvel engin ${res.data?.nouvelEnginCodeId || ''} (immatriculation vierge). ` +
                    `${res.data?.liensRepointes || 0} lien(s) repointé(s).`);
                // Journalisé côté serveur (EnginService.splitEnginPartage), après succès réel.
                setDetacherModalOpen(false);
                refreshContrat();
            })
            .catch((e) => {
                const status = e?.response?.status;
                const msg = e?.response?.data?.message || e?.response?.data?.reason
                    || (status === 409 ? "Cet engin n'est pas partagé par plusieurs contrats actifs." : null)
                    || (status === 403 ? "Vous n'avez pas le droit de détacher cet engin." : null)
                    || "Erreur lors du détachement de l'engin.";
                toast.error(msg);
            })
            .finally(() => setDetachingEnginCodeId(null));
    };

    const exportToOnePdf = () => {
        setLoadingPrinting(true);
        setTimeout(() => {
            //      handlePrint();
            handleExport();
        }, [500]);
    };

    const handleExport = async () => {
        setLoadingPrinting(true);
        try {
            const formData = new FormData();
            const pdfDoc = await PDFDocument.create();
            const attPdfDoc = await PDFDocument.create();
            const pageWidth = 1239, pageHeight = 1754;

            const refContrat = printRefContrat.current;
            const refAttestation = printRefAttestation.current;

            const processPdf = async (ref, doc, width, height) => {
                if (!ref) return;
                const canvas = await html2canvas(ref, { scale: 2, useCORS: true, backgroundColor: null });
                const imgBytes = await fetch(canvas.toDataURL('image/png')).then(res => res.arrayBuffer());
                const pdfImage = await doc.embedPng(imgBytes);
                const page = doc.addPage([width, height]);
                page.drawImage(pdfImage, { x: 0, y: 0, width, height });
            };

            await Promise.all([
                processPdf(refContrat, pdfDoc, pageWidth, pageHeight),
                processPdf(refAttestation, attPdfDoc, pageHeight, pageWidth)
            ]);

            // Save PDFs and create Blob
            const [pdfBytes, attPdfBytes] = await Promise.all([pdfDoc.save(), attPdfDoc.save()]);

            formData.append("cp", new File([new Blob([pdfBytes], { type: 'application/pdf' })], `condition_particuliere.pdf`));
            formData.append("att", new File([new Blob([attPdfBytes], { type: 'application/pdf' })], `attestation.pdf`));
            formData.append("contrat", contrat?.codeId);

            const response = await axiosMultiPartDataInstance.post('/api/contrat/impression', formData, {
                responseType: 'blob',
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            if (response.status === 200) {
                toast("Documents envoyés avec succès!");
                console.log("PDF generated successfully!", response);
            } else {
                toast("Erreur lors de l'envoi du document!");
                console.error("Error:", response);
            }
            console.log("PDF generated successfully!", response);
        } catch (error) {
            toast("Erreur lors de l'impression");
            console.error("Error:", error);
        } finally {
            setLoadingPrinting(false);
            setContratModal(false);
        }
    };

    // ── Export Excel de la flotte au MÊME format que l'import (FlotteExcelImport) ──
    // Réciproque exacte de validateAndTransformEngins : on reconstruit les 24 colonnes
    // attendues par l'import (donc le fichier exporté est ré-importable tel quel).
    const exportFlotteToExcel = () => {
        const engins = contrat?.engins || [];
        if (engins.length === 0) {
            toast.warning("Aucun engin à exporter.");
            return;
        }

        // immatriculation "TG 1234 AB" -> { typeSerie, matricule, numeroSerie }
        const parseImmat = (immat) => {
            const raw = String(immat || "").trim();
            const parts = raw.split(/\s+/);
            if (parts[0] === "TG" && parts.length >= 3) {
                return { typeSerie: "TG", matricule: parts[1], numeroSerie: parts.slice(2).join(" ") };
            }
            return { typeSerie: "Autre", matricule: raw, numeroSerie: "" };
        };

        // Volume/Puissance : pour une moto on expose le volume (cm³), pour un véhicule
        // la puissance d'origine (le champ volume contient l'équivalent essence converti
        // pour le DIESEL → ne pas l'exporter pour les véhicules).
        const volumePuissance = (e) => {
            const isMoto = `${e?.categorie?.codeCategorie ?? ""}`.toUpperCase().startsWith("M");
            const v = isMoto ? (e?.volume ?? e?.puissance) : (e?.puissance ?? e?.volume);
            return v ?? "";
        };

        const annee = (e) => {
            const d = e?.dateMiseEnCirculation;
            if (!d) return "";
            const m = String(d).match(/(\d{4})/);
            return m ? m[1] : "";
        };

        // Garanties supplémentaires : on émet les MÊMES jetons que le modèle interne,
        // càd les codeId des garanties (le Select stocke gar.codeId, et l'appli lit
        // engin.sousGaranties[].garantie.codeId — cf. Incorporation/EnginForm). C'est
        // donc la valeur ré-importable ; fallback sur le nom si codeId absent.
        const garantiesSupp = (e) => {
            const tokens = (Array.isArray(e?.sousGaranties) ? e.sousGaranties : [])
                .map((sg) => sg?.garantie?.codeId || sg?.garantie?.nom || sg?.codeId || sg?.nom)
                .filter(Boolean)
                .map(String);
            return Array.from(new Set(tokens)).join(";");
        };

        const rows = engins.map((e) => {
            const { typeSerie, matricule, numeroSerie } = parseImmat(e?.immatriculation);
            const p = e?.personne || {};
            const conducteurDifferent = (p && (p.nom || p.prenom)) ? "OUI" : "NON";
            const telephone = (Array.isArray(p?.contact) && p.contact[0]) ? p.contact[0] : (p?.telephone || "");
            return {
                "Type Série": typeSerie,
                "Matricule": matricule,
                "Numéro Série": numeroSerie,
                "Marque": e?.marque || "",
                "Énergie": e?.energie || "",
                "Usage": e?.usage || "",
                "Volume/Puissance": volumePuissance(e),
                "Nombre Places": e?.nombrePlace ?? "",
                "Genre": e?.genre || "",
                "N° Moteur": e?.moteur || "",
                "Type": e?.type || "",
                "N° Châssis": e?.numeroChassis || "",
                "Carrosserie": e?.carosserie || "",
                "Valeur Vénale": e?.valeurVenale ?? "",
                "Valeur Déclarée": e?.valeurDeclaree ?? "",
                "Valeur à Neuf": e?.valeurANeuf ?? "",
                "Année Mise en Circulation": annee(e),
                "Garanties Supplémentaires": garantiesSupp(e),
                "Conducteur Différent": conducteurDifferent,
                "Conducteur - Nom": conducteurDifferent === "OUI" ? (p.nom || "") : "",
                "Conducteur - Prénom": conducteurDifferent === "OUI" ? (p.prenom || "") : "",
                "Conducteur - Téléphone": conducteurDifferent === "OUI" ? telephone : "",
                "Conducteur - Adresse": conducteurDifferent === "OUI" ? (p.adresse || "") : "",
                "Conducteur - Profession": conducteurDifferent === "OUI" ? (p.profession || "") : "",
            };
        });

        const ws = XLSX.utils.json_to_sheet(rows);
        // Mêmes largeurs de colonnes que le modèle d'import.
        ws["!cols"] = [
            { wch: 12 }, { wch: 12 }, { wch: 15 }, { wch: 15 }, { wch: 12 },
            { wch: 10 }, { wch: 18 }, { wch: 15 }, { wch: 15 }, { wch: 15 },
            { wch: 12 }, { wch: 18 }, { wch: 15 }, { wch: 15 }, { wch: 15 },
            { wch: 15 }, { wch: 25 }, { wch: 30 }, { wch: 20 }, { wch: 20 },
            { wch: 20 }, { wch: 25 }, { wch: 25 }, { wch: 25 },
        ];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Flotte Engins");
        const ref = contrat?.numeroPoliceP || contrat?.numeroPoliceM || contrat?.codeId || "contrat";
        XLSX.writeFile(wb, `flotte_${String(ref).replace(/[^\w-]+/g, "_")}.xlsx`);
        toast(`${rows.length} engin(s) exporté(s) au format d'import.`);
    };

    const duplicata = () => {
        // console.log(numeroPaiement);
        confirm({
            title: "Etes-vous sûr de vouloir faire un duplicata?",
            icon: <ExclamationCircleFilled />,
            content: "Toutes vos actions sont historisées!",
            okText: "Oui, effectuer",
            okType: "danger",
            cancelText: "Annuler",
            onOk() {
                console.log("OK");
                avenantDuplicata();
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    };

    const avenantDuplicata = () => {
        toast("En cours de traitement...");
        axiosInstance.get(`/api/contrat/duplicata/${param.contratId}`)
            .then(res => {
                console.log("res.data ", res.data);
                navigate(`/details-contrat/${res.data.codeId}`, { replace: true });
                toast("Duplicata effectué avec succès!");
            }).catch(err => {
                console.log("err: ", err);
                toast("Erreur lors de l'envoi du duplicata!");
            });
    }


    return (
        <div class="layout-wrapper layout-content-navbar  ">
            <div class="layout-container">
                <SideBar currentMenu={"PRODUCTION"} />

                {/* <!-- Layout container --> */}
                <div class="layout-page">
                    <NavBar />

                    {/* <!-- Content wrapper --> */}
                    <div class="content-wrapper">
                        {/* <!-- Content --> */}
                        <div class="container-xxl flex-grow-1 container-p-y">

                            <div style={{
                                minHeight: '100vh',
                                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                                padding: '0'
                            }}>
                                {/* Header Section */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #242166 0%, #1e40af 100%)',
                                    padding: '12px 24px',
                                    boxShadow: '0 10px 40px rgba(36, 33, 102, 0.3)',
                                    marginBottom: '24px'
                                }}>
                                    <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
                                        <Row justify="space-between" align="middle" gutter={[16, 16]}>
                                            <Col xs={24} md={12}>
                                                <Space direction="vertical" size={4}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                                                        <FileTextOutlined style={{ fontSize: '28px', color: '#93c5fd' }} />
                                                        <h1 style={{
                                                            color: '#ffffff',
                                                            fontSize: '28px',
                                                            fontWeight: '700',
                                                            margin: 0
                                                        }}>
                                                            Contrat N° {contrat?.numeroAvenant ? contrat?.numeroAvenant : contrat?.numeroPoliceP ? contrat?.numeroPoliceP : contrat?.numeroPoliceM}
                                                        </h1>
                                                        {contrat?.commentaire?.startsWith('[REPRISE:') && (() => {
                                                            const source = contrat.commentaire.match(/\[REPRISE:([^\]]+)\]/)?.[1] || '';
                                                            return (
                                                                <Tag style={{ background: 'rgba(250,173,20,0.2)', border: '1px solid #faad14', color: '#faad14', borderRadius: '8px', padding: '4px 12px', fontSize: '12px', fontWeight: '700', letterSpacing: '0.5px' }}>
                                                                    📥 REPRISE {source}
                                                                </Tag>
                                                            );
                                                        })()}
                                                    </div>
                                                    <p style={{
                                                        color: '#93c5fd',
                                                        fontSize: '14px',
                                                        margin: 0,
                                                        marginLeft: '40px'
                                                    }}>
                                                        Détails et gestion du contrat d'assurance
                                                    </p>
                                                </Space>
                                            </Col>
                                            <Col xs={24} md={12} style={{ textAlign: 'right' }}>
                                                <Space size={12} wrap>
                                                    {contrat?.engins?.length > 0 && (
                                                        <Button
                                                            icon={<FileExcelOutlined />}
                                                            onClick={exportFlotteToExcel}
                                                            style={{
                                                                background: 'rgba(255, 255, 255, 0.15)',
                                                                color: '#fff',
                                                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                                                borderRadius: '10px',
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            Exporter la flotte (Excel)
                                                        </Button>
                                                    )}
                                                    {contrat?.engins?.length > 0 && rightsService("HCO103") && (
                                                        <Button
                                                            icon={<DisconnectOutlined />}
                                                            onClick={() => setDetacherModalOpen(true)}
                                                            style={{
                                                                background: 'rgba(255, 255, 255, 0.15)',
                                                                color: '#fff',
                                                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                                                borderRadius: '10px',
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            Détacher un engin partagé
                                                        </Button>
                                                    )}
                                                    <Card
                                                        size="small"
                                                        style={{
                                                            background: 'rgba(255, 255, 255, 0.15)',
                                                            backdropFilter: 'blur(10px)',
                                                            border: '1px solid rgba(255, 255, 255, 0.2)',
                                                            borderRadius: '12px'
                                                        }}
                                                        bodyStyle={{ padding: '12px 16px' }}
                                                    >
                                                        <Space direction="horizontal" size={2}>
                                                            <div style={{ color: '#93c5fd', fontSize: '11px' }}>Statut : </div>
                                                            <Tag
                                                                color={getStatusColor(contrat?.statutContrat)}
                                                                style={{
                                                                    margin: 0,
                                                                    borderRadius: '8px',
                                                                    padding: '4px 12px',
                                                                    fontSize: '13px',
                                                                    fontWeight: '600'
                                                                }}
                                                            >
                                                                {getStatusText(contrat?.statutContrat)}
                                                            </Tag>
                                                            {contrat?.corbeille && (
                                                                <Tag
                                                                    color="default"
                                                                    style={{
                                                                        margin: 0,
                                                                        borderRadius: '8px',
                                                                        padding: '4px 12px',
                                                                        fontSize: '13px',
                                                                        fontWeight: '600'
                                                                    }}
                                                                >
                                                                    En corbeille
                                                                </Tag>
                                                            )}
                                                        </Space>
                                                    </Card>
                                                </Space>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>

                                <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 24px 40px' }}>
                                    {/* Main Content Tabs */}
                                    <Card
                                        style={{
                                            borderRadius: '16px',
                                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                                            border: '1px solid #e5e7eb',
                                            overflow: 'hidden'
                                        }}
                                        bodyStyle={{ padding: 0 }}
                                    >
                                        <Tabs
                                            activeKey={activeTab}
                                            onChange={setActiveTab}
                                            size="large"
                                            centered
                                            style={{ margin: 0 }}
                                            tabBarStyle={{
                                                padding: '0 24px',
                                                margin: 0,
                                                background: 'linear-gradient(to bottom, #ffffff, #f9fafb)',
                                                borderBottom: '2px solid #e5e7eb'
                                            }}
                                        >
                                            <TabPane
                                                tab={
                                                    <span style={{ fontSize: '15px', fontWeight: '600' }}>
                                                        <FileTextOutlined style={{ marginRight: '8px' }} />
                                                        Détails
                                                    </span>
                                                }
                                                key="details"
                                            >
                                                {/* <div style={{ padding: '32px 24px' }}> */}
                                                <DetailsTab
                                                    contrat={contrat}
                                                    reglements={reglements}
                                                    contratModal={contratModal}
                                                    setContratModal={setContratModal}
                                                    openAvenantModifier={() => {
                                                        switch (contrat?.avenant?.code) {
                                                            case "RN": setModalRenouvellement(true); break;
                                                            case "PR": setModalProrogation(true); break;
                                                            case "IN": setModalIncorporation(true); break;
                                                            case "AG": setModalAugmentation(true); break;
                                                            case "DG": setModalDiminution(true); break;
                                                            case "TG": setModalTransfertGarantie(true); break;
                                                            case "RV": setModalRemiseEnVigueur(true); break;
                                                            default: break;
                                                        }
                                                    }}
                                                    avenantModalOpen={modalRenouvellement || modalProrogation
                                                        || modalIncorporation || modalAugmentation || modalDiminution
                                                        || modalTransfertGarantie || modalRemiseEnVigueur}
                                                    exportToPdf={exportToPdf}
                                                    duplicata={duplicata}
                                                    loadingPrinting={loadingPrinting}
                                                    setLoadingPrinting={setLoadingPrinting}
                                                    printingCP={printingCP}
                                                    exportToOnePdf={exportToOnePdf}
                                                    printingAttestation={printingAttestation}
                                                    printingCEDEAOAttestation={printingCEDEAOAttestation}
                                                    printedAttestation={printedAttestation}
                                                    attestationNodeRefs={attestationNodeRefs}
                                                    printedCEDEAOAttestation={printedCEDEAOAttestation}
                                                    printReference={printReference}
                                                    printRefContrat={printRefContrat}
                                                    printRefAttestation={printRefAttestation}
                                                    numeroAttestation={numeroAttestation}
                                                    printingDamagedAttestation={printingDamagedAttestation}
                                                    attestationDamagedPrinting={attestationDamagedPrinting}
                                                    attestationNonPrintedPrinting={attestationNonPrintedPrinting}
                                                    printAttestation={printAttestation}
                                                    attestationDamaged={attestationDamaged}
                                                    setAttestationDamaged={setAttestationDamaged}
                                                    setPrintingAttestation={setPrintingAttestation}
                                                    printingDamagedCEDEAOAttestation={printingDamagedCEDEAOAttestation}
                                                    setPrintingCEDEAOAttestation={setPrintingCEDEAOAttestation}
                                                    attestationCEDEAOPrinting={attestationCEDEAOPrinting}
                                                    attestationCEDEAODamagedPrinting={attestationCEDEAODamagedPrinting}
                                                    pdfPreviewUrl={pdfPreviewUrl}
                                                    setPdfPreviewUrl={setPdfPreviewUrl}
                                                    setNumeroAttestation={setNumeroAttestation}
                                                    rightsService={rightsService}
                                                    navigate={navigate}
                                                    showContractValidationConfirm={showContractValidationConfirm}
                                                    showCancelAvenantConfirm={showCancelAvenantConfirm}
                                                    showCancelValidationConfirm={showCancelValidationConfirm}
                                                    showCancelPropositionConfirm={showCancelPropositionConfirm}
                                                    showRestorePropositionConfirm={showRestorePropositionConfirm}
                                                    regle={regle}
                                                    modalAttOpen={modalAttOpen}
                                                    setModalAttOpen={setModalAttOpen}
                                                    modalCEDEAOAttOpen={modalCEDEAOAttOpen}
                                                    setModalCEDEAOAttOpen={setModalCEDEAOAttOpen}
                                                    onTabsChange={onTabsChange}
                                                    tabId={tabId}
                                                    attestationPrinting={attestationPrinting}
                                                    printAllAttestations={printAllAttestations}
                                                    printAllAttestationsRef={printAllAttestationsRef}
                                                    awaitingBulkConfirm={awaitingBulkConfirm}
                                                    confirmBulkPrintSuccess={confirmBulkPrintSuccess}
                                                    retryBulkPrint={retryBulkPrint}
                                                    abortBulkPrint={abortBulkPrint}
                                                    showAttestationCEDEAO={hasCEDEAOGarantie}
                                                    layout={layout}
                                                    setLayout={setLayout}
                                                />
                                                {/* </div> */}
                                            </TabPane>

                                            <TabPane
                                                tab={
                                                    <span style={{ fontSize: '15px', fontWeight: '600' }}>
                                                        <EditOutlined style={{ marginRight: '8px' }} />
                                                        Avenants
                                                    </span>
                                                }
                                                key="avenants"
                                                forceRender
                                            >
                                                <div style={{ padding: '12px 24px' }}>

                                                    <AvenantsTab
                                                        contrat={contrat}
                                                        reglements={reglements}
                                                        onRefresh={refreshContrat}
                                                        onAnnulerContrat={showAnnulationContratConfirm}
                                                        modalAugmentation={modalAugmentation}
                                                        updateAugmentationModal={setModalAugmentation}
                                                        modalDiminution={modalDiminution}
                                                        updateDiminutionModal={setModalDiminution}
                                                        modalProrogation={modalProrogation}
                                                        updateProrogationModal={setModalProrogation}
                                                        modalSuspension={modalSuspension}
                                                        updateSuspensionModal={setModalSuspension}
                                                        modalRemiseEnVigueur={modalRemiseEnVigueur}
                                                        updateRemiseEnVigueurModal={setModalRemiseEnVigueur}
                                                        modalReportEffet={modalReportEffet}
                                                        updateReportEffetModal={setModalReportEffet}
                                                        modalTransfertGarantie={modalTransfertGarantie}
                                                        updateTransfertGarantieModal={setModalTransfertGarantie}
                                                        modalChangementVehicule={modalChangementVehicule}
                                                        updateChangementVehiculeModal={setModalChangementVehicule}
                                                        modalRenouvellement={modalRenouvellement}
                                                        updateRenouvellementModal={setModalRenouvellement}
                                                        modalAvenantOrdre={modalAvenantOrdre}
                                                        updateAvenantOrdreModal={setModalAvenantOrdre}
                                                        modalAvenantOrdreEngin={modalAvenantOrdreEngin}
                                                        updateAvenantOrdreEnginModal={setModalAvenantOrdreEngin}
                                                        modalIncorporation={modalIncorporation}
                                                        updateIncorporationModal={setModalIncorporation}
                                                        modalRetrait={modalRetrait}
                                                        updateRetraitModal={setModalRetrait}
                                                        modalDuplicata={modalDuplicata}
                                                        updateDuplicataModal={setModalDuplicata}
                                                        modalResiliation={modalResiliation}
                                                        updateResiliationModal={setModalResiliation}
                                                        modalChangementProducteur={modalChangementProducteur}
                                                        updateChangementProducteurModal={setModalChangementProducteur}
                                                    />
                                                </div>
                                            </TabPane>
                                        </Tabs>
                                    </Card>
                                </div>
                            </div>
                        </div>

                        {/* <!-- / Content --> */}

                        {/* <!-- Footer --> */}
                        <Footer />
                        {/* <!-- / Footer --> */}

                        <div class="content-backdrop fade"></div>
                    </div>
                    {/* <!-- Content wrapper --> */}
                </div>
                {/* <!-- / Layout page --> */}
            </div>

            {/* <!-- Overlay --> */}
            <div class="layout-overlay layout-menu-toggle"></div>

            {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
            <div class="drag-target"></div>

            {fixCategorieData && (
                <FixEnginCategorieModal
                    open={!!fixCategorieData}
                    enginCodeId={fixCategorieData.enginCodeId}
                    immatriculation={fixCategorieData.immatriculation}
                    onFixed={() => {
                        setFixCategorieData(null);
                        axiosInstance.get(`/api/contrat/preview/${param?.contratId}`)
                            .then((res) => setPreview(res.data))
                            .catch((err) => console.log(err));
                    }}
                    onClose={() => setFixCategorieData(null)}
                />
            )}

            <Modal
                title="Détacher un engin partagé"
                open={detacherModalOpen}
                onCancel={() => setDetacherModalOpen(false)}
                footer={null}
                destroyOnClose
            >
                <p style={{ color: '#64748b', marginBottom: 16 }}>
                    À utiliser si un engin de ce contrat est <b>partagé à tort</b> avec d'autres contrats
                    (véhicules « à l'immatriculation »). Le détachement crée un <b>engin propre à ce contrat</b>,
                    avec une <b>immatriculation vierge</b> ; la plaque actuelle <b>reste</b> sur le contrat propriétaire
                    (aucune suppression).
                </p>
                <List
                    itemLayout="horizontal"
                    dataSource={contrat?.engins || []}
                    renderItem={(engin) => (
                        <List.Item
                            actions={[
                                <Button
                                    danger
                                    type="primary"
                                    icon={<DisconnectOutlined />}
                                    loading={detachingEnginCodeId === engin?.codeId}
                                    onClick={() => {
                                        Modal.confirm({
                                            title: "Confirmer le détachement",
                                            icon: <ExclamationCircleFilled />,
                                            content: `L'engin « ${engin?.immatriculation || 'sans immatriculation'} » sera détaché de ce contrat vers un engin neuf à immatriculation vierge. La plaque reste sur l'autre contrat. Continuer ?`,
                                            okText: "Détacher",
                                            okButtonProps: { danger: true },
                                            cancelText: "Annuler",
                                            onOk: () => detacherEnginPartage(engin),
                                        });
                                    }}
                                >
                                    Détacher
                                </Button>
                            ]}
                        >
                            <List.Item.Meta
                                title={engin?.immatriculation || <span style={{ color: '#94a3b8' }}>Sans immatriculation</span>}
                                description={`${engin?.marque || ''} · ${engin?.categorie?.nom || engin?.categorie?.codeCategorie || ''}`}
                            />
                        </List.Item>
                    )}
                />
            </Modal>
        </div>
    );
};

export default DetailsContrat;
